import {
  IPB_PACKAGE_BY_CHANNEL,
  IPB_PACKAGE_BY_CHANNEL_ERROR,
  CLEAN_IPB_PACKAGE_BY_CHANNEL,
  CLEAN_IPB_PACKAGE_BY_CHANNEL_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function ipbPackageByChannelReducer(state = initialState, action) {
  switch (action.type) {
    case IPB_PACKAGE_BY_CHANNEL:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case IPB_PACKAGE_BY_CHANNEL_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_IPB_PACKAGE_BY_CHANNEL:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_IPB_PACKAGE_BY_CHANNEL_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
